// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Pcrp","footer":"ModalUpdate_footer__1OQ_-"};